import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import ReactToPrint from "react-to-print";
import { Button, Form, Modal, FormGroup } from 'react-bootstrap';
import { QRCode } from "react-qrcode-logo";
import "../../../../assets/css/react-datetime.css";
import { encryptMessage } from '../../../helpers/common';
import { QR_TYPE } from '../../../constants';
import { Heading5, TitleIcon } from '../../widgets';
import { saveAs } from 'file-saver';

const EquipmentQRInfo = (props) => {
    const QRCryptoKey = useSelector(state => state.auth.qrSeceretKeys);
    const componentRef = useRef();
    const { data, QRType, showFilter, filterOptions, placeholder } = props;
    const [equipmentInfo, setEquipmentInfo] = useState(data ? data : null);
    const [selectedOption, setSelectedOption] = useState(showFilter ? 'all' : null);
    const disposeForm = () => {
        props.onHide();
    }

    const QRData = () => {
        const { v1 } = QRCryptoKey;
        const { id } = equipmentInfo;
        let QRValue = JSON.stringify({ id, type: QR_TYPE[QRType] });
        const enCryptValue = encryptMessage(QRValue, v1);
        return `v1:${enCryptValue}`;
    }

    const onFilterChange = (data) => {
        const value = (data && data.value) ? data.value : null;
        setSelectedOption(value);
        if (value && value !== 'all') {
            setEquipmentInfo(filterOptions.find((e) => e.id === value));
        } else {
            setEquipmentInfo(null);
        }
    }

    const optionsList = useMemo(() => {
        const defaultOption = [{ value: 'all', label: `All ${placeholder ? placeholder : ''}` }];
        let optList = (filterOptions && filterOptions.length > 0) ? filterOptions.map(e => ({ value: e.id, label: e.name })) : [];
        optList = (optList && optList.length > 0) ? [...defaultOption, ...optList] : optList;
        return optList;
    }, [filterOptions]);

    useEffect(() => {
        if (showFilter && optionsList && optionsList.length > 0 && equipmentInfo && equipmentInfo.id) {
            let option = optionsList.find((e) => e.value === equipmentInfo.id)
            if (option && option.value)
                setSelectedOption(option.value);
        }
    }, [showFilter])

    const generateExcelFile = () => {
        const { v1 } = QRCryptoKey;
        let csvContent = "Name,Category,UUID,QR Value\n";
        if (filterOptions && filterOptions.length > 0 && v1) {
            const filterdData = (selectedOption && selectedOption !== 'all') ?
                filterOptions.filter((e) => e.id === selectedOption) : filterOptions;
                
            filterdData.forEach((e) => {
                if (e.id) {
                    const ency = encryptMessage(JSON.stringify({ id: e.id, type: QR_TYPE[QRType] }), v1);
                    const enCryptValue = `v1:${ency}`;
                    csvContent += `${e.name ? e.name : ''},${e.subName ? e.subName : ''},${e.id},${enCryptValue}\n`;
                }
            })
            const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
            saveAs(blob, `qr_code_${Date.now().toString()}.csv`);
        }
    }

    return (
        <Modal show={props.show} onHide={disposeForm} backdrop="static" className="modal-form qr-modal">
            <Form className="eg-form">
                <Modal.Header closeButton>
                    <Modal.Title style={{ fontSize: '1.125rem' }}>
                        <Heading5>
                            <TitleIcon className="fa fa-qrcode" />Print QR
                        </Heading5>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {showFilter && <FormGroup className='mb-3'>
                        <Form.Select className="select-control-sm" placeholder={`Select ${placeholder ? placeholder : ''}`}
                            value={selectedOption}
                            options={optionsList}
                            onChange={onFilterChange}
                        >
                        </Form.Select>
                    </FormGroup>}
                    <div className='text-center' ref={componentRef}>
                        {equipmentInfo && <QRCode
                            value={QRData()}
                            size={250}
                            enableCORS={true}
                            qrStyle="squre"
                            eyeRadius={0}
                            id='eq-qr'
                        />}
                        <div className='printable-text mt-2'>
                            <div className='printable-title'>{equipmentInfo && equipmentInfo.name}</div>
                            <div className='printable-subtitle'>{equipmentInfo && equipmentInfo.subName && equipmentInfo.subName}</div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    {selectedOption && <Button className={`btn-sm qr-print-btn`} onClick={() => generateExcelFile()}>
                        <i className="fa fa-cloud-download mr-2" />Download CSV</Button>}
                    {equipmentInfo && <ReactToPrint
                        trigger={() => <Button variant='success' className='btn-sm qr-print-btn'><i className="fa fa-print mr-2" />Print</Button>}
                        content={() => componentRef.current}
                    />}
                </Modal.Footer>
            </Form>
        </Modal >)
}

export default EquipmentQRInfo